module.exports = __webpack_public_path__ + "img/3.3f5acc96.jpg";